import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import ScheduleTile from "../components/ScheduleTile";

function Home() {
  const day = useSelector((state) => state.auth?.user?.day);
  const schedule = useSelector((state) =>
    state.auth?.user?.schedule.filter((sch) => sch.day === day)
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="body-container">
      <h1 className="page-heading">Today's Schedule</h1>
      <h4 className="day-heading">{day}</h4>
      {schedule?.length > 0 ? (
        schedule?.map((item) => (
          <ScheduleTile
            key={item._id}
            faculty_name={item.teacher[0]?.faculty_name}
            course_name={item.subject[0]?.course_name}
            cls={item.class}
            room={item.room}
            campus={item.campus}
            time={item.Time}
          />
        ))
      ) : (
        <div className="no-schedule">No class scheduled today!</div>
      )}
    </div>
  );
}

export default Home;
